import { getIncentiveBadgeText } from '@carvana/merch-tile';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useIncentives from '~/hooks/vdp/selectors/useIncentives';
import useShowMiniHeroInfoCard from '~/hooks/vdp/useShowMiniHeroInfoCard';
import FactoryUpgradesBadge from './FactoryUpgradesBadge';
import IncentivesBadge from './IncentivesBadge';

export default function Highlights() {
  const { factoryUpgrades } = useGetVehicleDetails();
  const { additionalIncentives, appliedIncentives } = useIncentives();
  const showMiniHeroInfoCard = useShowMiniHeroInfoCard();

  const badgeText = getIncentiveBadgeText({
    additionalIncentives,
    appliedIncentives
  });
  const showLoyaltyIncentives = Boolean(badgeText);
  const factoryUpgradesMsrp = factoryUpgrades?.factoryUpgradesMsrp ?? 0;
  const showFactoryUpgrades = Boolean(factoryUpgradesMsrp);

  if (showMiniHeroInfoCard) return null;

  return showFactoryUpgrades || showLoyaltyIncentives ? (
    <div className="flex w-full flex-col gap-sm pt-md">
      {badgeText && <IncentivesBadge badgeText={badgeText} />}
      {showFactoryUpgrades && (
        <FactoryUpgradesBadge factoryUpgradesMsrp={factoryUpgradesMsrp} />
      )}
    </div>
  ) : null;
}
